export default __webpack_public_path__ + "static/media/ski_badge.58425430.png";